/**
 * SFrame258 — Estate completion validator & archive transition.
 */

import { useParams, Link } from 'react-router-dom';
import ClosePhaseChrome from './ClosePhaseChrome';
import EstateCompletionValidator from '../settlement/EstateCompletionValidator';
import { useSettlement } from '../../contexts/SettlementContext';

export default function SFrame258() {
  const { estateId } = useParams<{ estateId: string }>();
  const { isArchived, refreshClosure } = useSettlement();
  const suffix = estateId ? `/${estateId}` : '';

  return (
    <ClosePhaseChrome
      estateId={estateId}
      title="Validate & archive"
      subtitle="The server enforces every requirement before the estate can enter read-only archive mode."
    >
      <EstateCompletionValidator
        estateId={estateId ?? null}
        readOnly={isArchived}
        onClosed={refreshClosure}
      />
      <div className="flex flex-wrap gap-4 text-sm print:hidden">
        <Link to={`/sframe-257${suffix}`} className="text-blue-800 hover:underline">
          ← Close accounts
        </Link>
        <Link to={`/sframe-259${suffix}`} className="font-medium text-blue-800 hover:underline">
          Final records & confirmation →
        </Link>
      </div>
    </ClosePhaseChrome>
  );
}
